<template>
  <BaiduProvider
    :apiKey="getConfig.baiduMapsApiKey"
    :markers="markers"
    :options="{
      zoom,
      center,
      mapTypeSelector,
    }"
  >
    <slot></slot>
  </BaiduProvider>
</template>

<script>
import BaiduProvider from "./BaiduProvider";
import config from "../config";

export default {
  name: "vue-map",
  components: {
    BaiduProvider,
  },
  props: {
    markers: {
      type: Array,
    },
    center: {
      type: Object,
    },
    zoom: {
      type: Number,
    },
    mapTypeSelector: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getConfig() {
      return config;
    },
  },
};
</script>
